import type { RegionDetail } from '../../../../api/regions';

import { InheritedDirector } from './InheritedDirector';
import { StrandedDirector } from './StrandedDirector';

/**
 * Directors live on top-level regions, so a subregion never gets the assignment
 * dropdown. It does get a clear: that is the only way out of the stranded state.
 */
export function SubregionDirector({
  detail,
  onClear,
  clearing,
}: {
  detail: RegionDetail;
  onClear: () => void;
  clearing: boolean;
}) {
  return detail.directorName !== null ? (
    <StrandedDirector detail={detail} onClear={onClear} clearing={clearing} />
  ) : (
    <InheritedDirector detail={detail} />
  );
}
